import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import medalImage from "../../assets/img/Rewardpoints.PNG";
import axios from "axios";

const RewardPointsCard = () => {
  const [visitCount, setVisitCount] = useState();
  const location = useLocation();

  useEffect(() => {
    const fetchUsePoints = async () => {
      let username = localStorage.getItem("username");
      try {
        const response = await axios.get(
          `https://s3napi.s3nsoftware.com/api/WordOfTheDay/GetUsePoints?username=${username}`
        );
        const count = response.data;
        setVisitCount(count);
      } catch (error) {
        console.error("Failed to fetch use points:", error);
      }
    };

    fetchUsePoints();
  }, []);

  // useEffect(() => {
  //   const pageKey = `visited-${location.pathname}`;
  //   if (!sessionStorage.getItem(pageKey)) {
  //     sessionStorage.setItem(pageKey, "true");
  //     const count = parseInt(localStorage.getItem("count") || "0", 10);
  //     const newCount = count + 1;
  //     localStorage.setItem("count", newCount);
  //     setVisitCount(newCount);
  //   } else {
  //     const currentCount = parseInt(localStorage.getItem("count") || "0", 10);
  //     setVisitCount(currentCount);
  //   }
  // }, [location.pathname]);

  return (
    <div style={styles.card}>
      <div style={styles.iconSection}>
        <img src={medalImage} alt="Medal Icon" style={styles.medalImage} />
      </div>
      <div style={styles.infoSection}>
        <h3 style={styles.title}>Reward Points</h3>
        <p style={styles.subtitle}>You have {visitCount} points!</p>
      </div>
    </div>
  );
};

const styles = {
  card: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    maxWidth: "400px",
    fontFamily: "sans-serif",
  },
  iconSection: {
    marginRight: "16px",
  },
  medalImage: {
    width: "64px",
    height: "64px",
    objectFit: "contain",
  },
  infoSection: {
    flex: 1,
  },
  title: {
    margin: "0 0 4px 0",
    fontSize: "18px",
    fontWeight: "bold",
  },
  subtitle: {
    margin: 0,
    fontSize: "14px",
    color: "#555",
  },
};

export default RewardPointsCard;
